import React, { FC } from 'react';

import getClassName from 'src/common/utils/getClassName';
import Svg from '../Svg';
import s from './StarIcon.module.scss';

type StarIconProps = {
  classNameModifier?: string;
};

const StarIcon: FC<StarIconProps> = ({ classNameModifier }) => (
  <Svg
    href="#old-star"
    className={getClassName(s, 'root', classNameModifier)}
    data-test="star"
  />
);

export default StarIcon;
